import NewsArticle from './NewsArticle';
export default NewsArticle;
